<template>
    <div class="delivery">
        <div class="element">
            <div class="label">{{$t('automatic.deliveries.selectPlace')}}:</div>
            <div class="content">
                <multiselect
                        :allowEmpty="false"
                        :options="deliveryType"
                        :placeholder="$t('automatic.deliveries.selectPlace')"
                        :searchable="false"
                        :show-labels="false"
                        v-model="selectedType"

                ></multiselect>
                <div class="remove">
                    <a @click.prevent="$emit('removeDelivery',delivery.index)"
                       href="/">{{$t('general.remove')}}</a>
                </div>
            </div>
        </div>
        <div class="data">
            <div class="e-mail" v-if="selectedType === 'e-mail'">
                <div class="element">
                    <div class="label">{{$t('automatic.deliveries.email')}}:</div>
                    <input :placeholder="$t('automatic.deliveries.email')" name="email"
                           key="email" type="text" v-model="email" v-validate.immediate="'required|email'">
                    <span>{{ errors.first('email') }}</span>
                </div>
            </div>
            <div class="ftp" v-else>
                <div class="element">
                    <div class="label">{{$t('automatic.deliveries.host')}}:</div>
                    <input :placeholder="$t('automatic.deliveries.host')" name="host" type="text" v-model="host"
                           key="host" v-validate.immediate="'required'">
                    <span>{{ errors.first('host') }}</span>
                </div>
                <div class="element">
                    <div class="label">{{$t('automatic.deliveries.directory')}}:</div>
                    <input :placeholder="$t('automatic.deliveries.directory')" name="directory"
                           key="directory" type="text" v-model="directory" v-validate.immediate="'required'">
                    <span>{{ errors.first('directory') }}</span>
                </div>
                <div class="element">
                    <div class="label">{{$t('automatic.deliveries.user')}}</div>
                    <input :placeholder="$t('automatic.deliveries.user')" name="user" type="text" v-model="user"
                           key="user" v-validate.immediate="'required'">
                    <span>{{ errors.first('user') }}</span>
                </div>
                <div class="element">
                    <div class="label">{{$t('automatic.deliveries.password')}}:</div>
                    <input :placeholder="$t('automatic.deliveries.password')" name="password" type="password"
                           key="password" v-model="password" v-validate.immediate="'required'">
                    <span>{{ errors.first('password') }}</span>
                </div>
                <div class="element">
                    <div class="label">SSL</div>
                    <multiselect
                            :allowEmpty="false"
                            :options="yesNo"
                            :searchable="false"
                            :show-labels="false"
                            label="label"
                            placeholder="SSL"
                            track-by="id"
                            v-model="ssl"
                    ></multiselect>
                </div>
                <div class="element">
                    <div class="label">{{$t('automatic.deliveries.passive')}}:</div>
                    <multiselect
                            :allowEmpty="false"
                            :options="yesNo"
                            :placeholder="$t('automatic.deliveries.passive')"
                            :searchable="false"
                            :show-labels="false"
                            label="label"
                            track-by="id"
                            v-model="passive"
                    ></multiselect>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'Delivery',
  components: {
    Multiselect,
  },
  props: {
    delivery: {
      type: Object,
    },
  },
  data() {
    return {
      deliveryType: ['e-mail', 'FTP'],
      selectedType: 'e-mail',
      yesNo: [{id: true, label: this.$t('general.yes')},
        {id: false, label: this.$t('general.no')}],
      passive: {id: false, label: this.$t('general.no')},
      ssl: {id: false, label: this.$t('general.no')},
      loaded: false,
      email: '',
      host: '',
      password: '',
      user: '',
      directory: '',
    };
  },
  watch: {
    selectedType(newValue) {
      this.errors.clear();
      if (newValue === 'e-mail') {
        this.delivery.selectedType = 'e-mail';
        this.delivery.mail = this.email;
        this.passive = {id: false, label: this.$t('general.no')};
        this.ssl = {id: false, label: this.$t('general.no')};
        this.host = '';
        this.password = '';
        this.user = '';
        this.directory = '';
      } else {
        //this.email = '';
        this.delivery.selectedType = 'FTP';
      }
    },
    ssl(newValue) {
      this.delivery.ssl = newValue.id;
    },
    passive(newValue) {
      this.delivery.passive = newValue.id;
    },
    email(newValue) {
      this.delivery.mail = newValue;
    },
    host(newValue) {
      this.delivery.host = newValue;
    },
    password(newValue) {
      this.delivery.password = newValue;
    },
    user(newValue) {
      this.delivery.user = newValue;
    },
    directory(newValue) {
      this.delivery.directory = newValue;
    },
  },
  mounted() {
    this.loaded = true;
    if (this.delivery.selectedType === 'e-mail') {
      this.email = this.delivery.mail;
      this.selectedType = 'e-mail';
    }
    if (this.delivery.selectedType === 'FTP') {

      if (this.delivery.passive !== undefined) {
        this.passive = this.yesNo.find(t => t.id === this.delivery.passive);
      } else {
        this.passive = {id: false, label: this.$t('general.no')};
      }
      if (this.delivery.ssl !== undefined) {
        this.ssl = this.yesNo.find(t => t.id === this.delivery.ssl);
      } else {
        this.ssl = {id: false, label: this.$t('general.no')};
      }
      this.host = this.delivery.host;
      this.password = this.delivery.password;
      this.user = this.delivery.user;
      this.directory = this.delivery.directory;
      this.selectedType = 'FTP';
    }
  },
};
</script>

<style lang="scss" scoped>
    .delivery {
        margin: 15px auto;
        border-top: 1px solid $border-gray;
        border-bottom: 1px solid $border-gray;

        &:not(:first-child) {
            border-top: none;
        }

        display: flex;
        flex-direction: column;
    }

    .element {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin: 15px auto;

        .label {
            text-align: left;
            font-weight: bold;
        }
    }

    input {
        color: #878a94;
        font-size: rem(14px);
        line-height: 19px;
        padding: 20px;
        box-sizing: border-box;
        width: 95%;
        height: 100%;
        border: 1px solid $border-blue;
    }

    .content {
        display: flex;
        flex-direction: row;

        a {
            margin-left: 17px;
            text-decoration: none;
            color: #005fab;

            &:active, &:hover, &:visited {
                color: #005fab;
            }
        }
    }
</style>
